import type { FaireProductEntity } from "../../entity_types/product";

export const p_dpnjbsfc75: FaireProductEntity = {
  token: "p_dpnjbsfc75",
  type: "product",
  name: "Clear Quartz Double-Terminated Points",
  brandToken: "b_52zr2whq85",
  brandName: "Jensen Rocks",
  imageUrl:
    "https://cdn.faire.com/fastly/e884694b8c2b57e001e9e9c7beb956c23787ab49f79585ceee1829aa71bfc485.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/6d944e80739234c7bcde9b1a505ab8bfc866c37c8b27901d2eae1287638c77e8.jpeg",
    "https://cdn.faire.com/fastly/2096681a00fee9d996270814afc91a8683089ec55380ccd5be8a217788dc5860.jpeg",
  ],
  priceDollars: 277.14,
  description:
    "Our Clear Quartz Double-Terminated Points are all stunning. They exhibit consistent clarity with inclusions throughout.\n\nDouble-Terminated Clear Quartz Crystals feature pointed ends, facilitating energy flow in both directions.\n\nPhotos accurately represent the product you will receive.\n\nSlight variations in color, size and natural formation are to be expected.\n\nYou can choose either a 10 Piece lot or a 60 Piece lot for our price break. \n",
  tags: [],
  msrpDollars: 665.13,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:01:51.365Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
